import { createContext } from 'react';

const initialState = { connections: {} };

export const SocketContext = createContext<typeof initialState>(initialState);